<template>
  <div id="app">

    <!-- 提示页面 -->
    <app-tips 
    :tipInfo="tipInfo" 
    :btnshow="btnshow"
    :btnreload="btnreload"
    :btnpay="btnpay"
    :machineId="machineId"
    @tipShow="tipShow" 
    @countinuePay="countinuePay"
    v-show="tipshow"></app-tips>
   <!-- Mqtt确认货机是否在线-->
   <!-- 进入页面遮罩 -->
   <app-machine-alive  v-if="machine_alive"></app-machine-alive>
   <app-mqtt :imei="imei" @machineStatus="machineStatus" ref="mychild"></app-mqtt>
   <!-- 头部-->
   <app-header :headInfo="headInfo" :shopInfo="shopInfo"></app-header>
   <!-- 导航 -->
   <app-nav :commentNum="commentNum" :machineId = "machineId" ></app-nav> 
   <!-- 货机状态 -->
   <app-m-status v-if="machinestatus"></app-m-status>
   <!-- 内容 -->
   <keep-alive>
      <router-view 
      @selectGoods="selectGoodsPay" 
      @showTip="showTip" 
      @chooseGoods = "handleChooseGoods"
      :machineId = "machineId"
      :cartType = "cartType"
      :shopInfo = "shopInfo"
      :bsoll = "bsoll"
      v-if="multi_page"
      ></router-view>
   </keep-alive>
   <!-- 确认订单 -->
  <order-page 
    v-if="order_page"
    :orderInfo="orderInfo"
    :machineId="machineId"
    :show_back = "multi_page"
    :source="source"
    :showPayBtn="showPayBtn"
    @confirm="handleConfirm"
    @back="handleBack"
  ></order-page>
  <!-- 购物车支付页面 -->
  <pay-page
    v-if="pay_page"
    :cartOrderInfo="cartOrderInfo"
    :machineId="machineId"
    :show_back = "multi_page"
    :source="source"
    :showPayBtn="showPayBtn"
    @confirm="handleConfirm"
    @back="handleBack"
  ></pay-page>
  <!-- 支付成功 -->
  <pay_success_page v-if="pay_success_page"></pay_success_page>
  <!-- 支付失败 -->
  <pay_fail_page v-if="pay_fail_page"  :shopInfo="shopInfo"></pay_fail_page>
  <!-- 查询付款状态页面 -->
  <pay_await_page v-if="pay_await_page"></pay_await_page>
  <!-- 等待出货 -->
  <goods_push_page v-if="goods_push_page"></goods_push_page>
  <!-- 出货成功 -->
  <goods_push_success_page v-if="goods_push_success_page"></goods_push_success_page>
  <!-- 出货失败 -->
  <goods_push_fail_page v-if="goods_push_fail_page" :shopInfo="shopInfo"   :requestNum="requestNum" :putOrderInfo="putOrderInfo"></goods_push_fail_page>
  </div>
</template>

<script>
import Mqtt from './components/Mqtt/Mqtt'
import Header from './components/Header/Header'
import Nav from './components/Nav/Nav'
import machinestatus from './components/machinestatus/machinestatus'
import Tips from './components/tips/Tips'
import MachineAlive from './components/tips/MachineAlive'
import orderPage from './components/orderPage/orderPage'
import payPage from './components/payPage/payPage'
import goodsPushPage from './components/goodsPushPage/goodsPushPage'
import goodsPushSuccessPage from './components/goodsPushSuccessPage/goodsPushSuccessPage'
import goodsPushFailPage from './components/goodsPushFailPage/goodsPushFailPage'
import paySuccessPage from './components/paySuccessPage/paySuccessPage'
import payFailPage from './components/payFailPage/payFailPage'
import payAwaitPage from './components/payAwaitPage/payAwaitPage'
export default {
  name: 'App',
  components:{
      "app-mqtt":Mqtt,
      "app-header":Header,
      "app-nav":Nav,
      "app-m-status":machinestatus,
      "app-tips":Tips,
      "app-machine-alive":MachineAlive,
      "order-page":orderPage,
      "pay-page":payPage,
      "goods_push_page":goodsPushPage,
      "goods_push_success_page":goodsPushSuccessPage,
      "goods_push_fail_page":goodsPushFailPage,
      "pay_success_page":paySuccessPage,
      "pay_fail_page":payFailPage,
      "pay_await_page":payAwaitPage
  },
  data(){
    return{
      poiInfo:{},
      commentNum:0,
      headInfo:{},//头部轮播图信息
      orderInfo:{
        No:'',
        capacity:'',
        goods_id:'',
        machine_id:'',
        merchantId:'',
        goods:{
          goodsId:'',
          goodsImage:'',
          goodsName:'',
          goodsPrice:'',
          goodsUnit:''
        }
      },//确认订单信息
      cartOrderInfo:{},//购物车订单信息
      putOrderInfo:{
            userId:"",
            openid:"",
            source:"",
            merchantId:"",
            operationId:"",
            machineId:"",
            check:true,
            goods:[]
      },//提交的订单信息
      shopInfo:{},//货机信息
      tipInfo:"",
      cartType:0, //购物车是否启用  1启用   0关闭
      tipshow:false,
      btnshow:true,
      btnreload:false,
      btnpay:false,
      tipReload:false,//tips页面是否刷新页面
      machine_alive:true,
      machinestatus:false,
      commentNum:0,
      source:0,//入口  微信 WeiXIN  支付宝 Alipay
      multi_page:true,//选择商品 true为开启  false为关闭  与order_page 配合使用
      order_page:false,  //确认订单页面 扫描货道 true为开启  false为关闭   与multi_page 配合使用
      pay_page:false,   //同上
      pay_success_page:false,  //支付成功页面
      pay_fail_page:false,  //支付失败页面
      pay_await_page:false,  //支付查询页面
      goods_push_page:false,  //等待出货页面
      goods_push_success_page:false,  //出货成功页面
      goods_push_fail_page:false,  //出货失败页面
      machineId:"",//货机id
      imei:"",
      freight_way:"", //货道号
      aisle_code:"", //用户code
      openid:"",//用户openid
      userid:"",//用户userid
      state:"",//跳转后带的参数
      bankRequestNum:"",  //银行流水号
      orderNum:"",  //订单号
      requestNum:"",  //请求编号
      res:{},
      showPayBtn:true,
      bsoll:false //商品滚动
    }
  },

  created(){
    //解决后退刷新问题
    // window.onpageshow = function(event) {
    // 　　if (event.persisted) {
    // 　　　　window.location.reload();
    // 　　}
    // };

    if(this.$route.query.machineId){
      this.machineId = this.$route.query.machineId
      // 线上测试时打开
      // if(this.machineId != 669){
      //   this.showMessage("系统正在维护，预计需要15到20分钟，给您代来不便，敬请谅解！")
      // }
    }else{
          //alert('获取数据错误，请您重新扫码，谢谢！');
          this.tipInfo = "获取数据错误，请您重新扫码，谢谢！";
          this.tipshow = true;
          this.btnshow = false;
          setTimeout(function(){
            window.opener=null;
            window.close();
          },3000)
          return;
    }
    if(this.$route.query.freight_way){
        this.freight_way = this.$route.query.freight_way
    }
    
    //使用客户公众号的时候在这里调用获取商户公众号appId的api 

    //识别扫描入口
   var ua = window.navigator.userAgent.toLowerCase();
      if ( ua.match(/MicroMessenger/i) == 'micromessenger' ) {  
            //判断是不是微信
            this.source = 1;
            //重定向获取用户code的链接

            //调用
            if(this.$route.query.code){
                this.aisle_code = this.$route.query.code
                //alert(this.aisle_code)
            }
            if(this.$route.query.state){
                this.state = this.$route.query.state
                let a = this.state.split(".")
                this.machineId = a[0]
                this.freight_way = a[1] 
            }
            if(this.$route.query.machineId){
                this.state = this.$route.query.machineId+"."
            }
            if(this.$route.query.freight_way){
                this.state = this.state +this.$route.query.freight_way
            }


            //显示提示
            // if(this.machineId != 300 && this.machineId != 279){
            //     this.multi_page = false;
            //     this.tipInfo = "系统正在维护,请您耐心等待！";
            //     this.tipshow = true;
            
            // }
            //my-appid ="wx848cbdb2c3c18c49"
            //hrc-appid="wx47edb2ad95cd8fbe"
            //if(this.machineId == 300 || this.machineId == 279){
                if(this.aisle_code == ""){
                  window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx47edb2ad95cd8fbe&redirect_uri=http%3A%2F%2Fweb.hrcc8.com%2F%3FmachineId%3D"+this.machineId+"%26freight_way%3D"+this.freight_way+"&response_type=code&scope=snsapi_base&state="+this.state+"#wechat_redirect";

                  //window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx848cbdb2c3c18c49&redirect_uri=http%3A%2F%2Ftest.hrcc8.com%2F%3FmachineId%3D"+this.machineId+"%26freight_way%3D"+this.freight_way+"&response_type=code&scope=snsapi_base&state="+this.state+"#wechat_redirect";
                  return;
                } 
            //}

      } else if (ua.match(/AlipayClient/i) == 'alipayclient') {
          //判断是不是支付宝
          this.source = 2;
          if(this.$route.query.auth_code){
                this.aisle_code = this.$route.query.auth_code
            }
            if(this.$route.query.state){
                this.state = this.$route.query.state
                let a = this.state.split(".")
                this.machineId = a[0]
                this.freight_way = a[1] 
            }
            if(this.$route.query.machineId){
                this.state = this.$route.query.machineId+"."
            }
            if(this.$route.query.freight_way){
                this.state = this.state +this.$route.query.freight_way
            }
            //my_app_id = 2021002109692872
            //hrc_app_id = 2021001193602759
            // if(this.machineId != 300 && this.machineId != 279){
            //   this.multi_page = false;
            //   this.tipInfo = "系统正在维护,请您耐心等待！";
            //   this.tipshow = true;
          
            // }
            //if(this.machineId == 300 || this.machineId == 279){
                if(this.aisle_code == ""){
                  window.location.href = "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021001193602759&scope=auth_base&redirect_uri=http%3A%2F%2Fweb.hrcc8.com%2F%3FmachineId%3D"+this.machineId+"%26freight_way%3D"+this.freight_way+"&state="+this.state;

                  //window.location.href = "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021001193602759&scope=auth_base&redirect_uri=http%3A%2F%2Ftest.hrcc8.com%2F%3FmachineId%3D"+this.machineId+"%26freight_way%3D"+this.freight_way+"&state="+this.state;
                  return;
                }
            //}
      } else {
          //哪个都不是退出
          // alert('请使用微信或支付宝扫码，谢谢！');
          this.tipInfo = "请使用微信或支付宝扫码，谢谢！";
          this.tipshow = true;
          this.btnshow = false;
          setTimeout(function(){
            window.opener=null;
            window.close();
          },3000)
          return ;
      }

    if (this.aisle_code != "") {
        // 向后端换取openid http://hrcc8.com/api/users
        fetch("https://hrcc8.com/api/userscatr/?code="+this.aisle_code+"&source="+this.source)
        .then(res => {
          return res.json()
        })
        .then(response =>{
          if(response.code == 0){
            // 解决刷新code不变的问题
            if(response.data.errcode){
              window.location.href = "https://web.hrcc8.com/?machineId="+this.machineId+"&freight_way="+this.freight_way
            } 
            //获取openid 和 userid
            this.openid = response.data.openid
            this.userid = response.data.userId
            //alert(this.openid)
            //alert(this.userid)
          }
        })
      }
    if(this.freight_way != ""){
        //访问单货道商品接口然后将相关信息推送到页面
        fetch("https://hrcc8.com/api/getGoodsFreight?machineId="+this.machineId+"&freightWay="+this.freight_way)
        .then(res => {
          return res.json()
        })
        .then(response =>{
          if(response.code == 0){ 
            this.orderInfo = response.data
            //添加货道信息
            let info = {};
            let p_info = Array();
                p_info[0]='{"No":'+this.orderInfo['No']+',"count":1,"goods_id":'+this.orderInfo['goods_id']+',"price":'+this.orderInfo['price']+'}';
                // p_info[0]={
                //       "No":this.orderInfo['No'],
                //       "count":1,
                //       "goods_id":this.orderInfo['goods_id'],
                //       "price":this.orderInfo['price']
                //     };
            info['total_price'] = this.orderInfo['price'];
            info['total_count'] = 1;
            info['No_list'] = this.orderInfo['No'];
            info['machine_id'] = this.orderInfo['machine_id'];
            info['merchantId'] = this.orderInfo['merchantId'];
            info['operationId'] = this.orderInfo['operationId'];
            info['goods'] = p_info;
            this.cartOrderInfo = info;
            //console.log(this.cartOrderInfo)
          }else if(response.code == 404){
            this.machineDown()
          }else if(response.code == 405){
            this.machineOver()
          }else{
            //alert("获取单货道数据出现错误！")
            this.tipInfo = "获取单货道数据出现错误！";
            this.tipshow = true;
            this.btnshow = false;
            setTimeout(function(){
              window.opener=null;
              window.close();
            },3000)
            return;
          }
        })

        this.multi_page = false

        this.order_page = true
    }

    //头部图片
    fetch("https://hrcc8.com/api/HeaderAdvertising?machineId="+this.machineId)
      .then(res => {
        return res.json()
      })
      .then(response =>{
        if(response.code == 0 || response.code == 407){
        this.headInfo = response.data.data
          //判断是否有app头标题信息
          if(response.data.title == undefined)
          {
            document.title = "恒瑞成";
          }else{
            document.title = response.data.title;
          }
          
        }
      })
    //获取商户信息
    fetch("https://hrcc8.com/api/shop/?machineId="+this.machineId)
      .then(res => {
        return res.json()
      })
      .then(response =>{
        if(response.code == 0){ 
          if(response.data.machinesname == undefined){
            response.data.machinesname = "星星的店"
          }else{
            if(response.data.machinesname == ""){
                response.data.machinesname = "星星的店"
            }
            
            //判断商户是否配置了支付账户信息，如果没有配置则提示客户
          }
          this.shopInfo = response.data
          this.imei = response.data.machimei  //获取设备的imei
          //调用mqtt获取设备状态
          //if(this.aisle_code != ""){
            if(this.imei != ''){
              this.$refs.mychild.mqttMSG(this.imei)
            }
          //}
          //console.log(this.imei)
          //根据商户设定来开启0或关闭购物车1
          this.cartType = response.data.iscart
        }
      })
    
  },
  methods: {
    showTip(info){
      this.tipInfo = info
      this.tipshow = true
    },
    showMessage(info){
      this.tipInfo = info
      this.tipshow = true
      this.btnshow = false
    },
    tipShow(){
      this.tipshow = false
      if(this.tipReload){
        //刷新页面
        location.reload();
      }
    },
    countinuePay(){
      console.log('continuePay');
      this.tipshow = false;
      this.putOrderInfo.check = false;
      //this.handleConfirm();
    },
    machineDown: function(){
      //alert("当前设备已离线！");
      this.tipInfo = "当前设备已离线！";
      this.tipshow = true;
      this.btnshow = false;
      setTimeout(function(){
        window.opener=null;
        window.close();
      },3000)
      return
    },
    machineOver: function(){
      //alert("当前设备已过期！");
      this.tipInfo = "当前设备已过期！";
      this.tipshow = true;
      this.btnshow = false;
      setTimeout(function(){
        window.opener=null;
        window.close();
      },3000)
      return
    },
    handleChooseGoods: function(that){ //不带购物车的时候获取订单数据
      this.orderInfo = that
      console.log(this.orderInfo)
      //添加货道信息
      let info = {};
      let p_info = Array();
          p_info[0]='{"No":'+that['No']+',"count":1,"goods_id":'+that['goods_id']+',"price":'+that['price']+'}';
          // p_info[0]={
          //       "No":that['No'],
          //       "count":1,
          //       "goods_id":that['goods_id'],
          //       "price":that['price']
          //     };
      info['total_price'] = that['price'];
      info['total_count'] = 1;
      info['No_list'] = that['No'];
      info['machine_id'] = that['machine_id'];
      info['merchantId'] = that['merchantId'];
      info['operationId'] = that['operationId'];
      info['goods'] = p_info;
      info['goods_id'] = that['goods_id'];
      this.cartOrderInfo = info;
      //console.log(this.cartOrderInfo)

      this.multi_page = false
      this.order_page = true
    },
    handleConfirm: function(){
      //判断一下url
      // if(this.$route.query.code == undefined && this.$route.query.auth_code == undefined){
      //     window.location.href = "http://web.hrcc8.com/?machineId="+this.machineId+"&freight_way="+this.freight_way
      // }

      //隐藏支付按钮
      this.showPayBtn = false
      //获取订单信息
      /*
      
      
         
      用户id: userId
      用户openid: openid
      入口：source
      商家id：merchantId
      维护者id：operationId
      货机id：machineId
      商品货道信息：goods{
                货道号：mainboradNo
                商品id：goodsId 
                单货道购买数量：count
                单价：price
            }
      */
      //将信息插入orderInfo中
    if(this.cartType == 1){
      this.putOrderInfo.userId = this.userid
      this.putOrderInfo.openid = this.openid
      this.putOrderInfo.source = this.source
      this.putOrderInfo.merchantId = this.cartOrderInfo.merchantId
      this.putOrderInfo.operationId = this.cartOrderInfo.operationId 
      this.putOrderInfo.machineId = this.cartOrderInfo.machine_id
      this.putOrderInfo.goods = this.cartOrderInfo.goods
      var url = "https://hrcc8.com/api/ordercatr" //下单接口
      //var url = "http://hrc/api/ordercatr" //下单接口
      //alert(url)
    }
    if(this.cartType == 0){
      this.putOrderInfo.goodsId = this.cartOrderInfo.goods_id
      this.putOrderInfo.machineId =  this.cartOrderInfo.machine_id
      this.putOrderInfo.mainboradNo = this.cartOrderInfo.No_list
      this.putOrderInfo.userId = this.userid
      this.putOrderInfo.openid = this.openid
      this.putOrderInfo.merchantId = this.cartOrderInfo.merchantId
      this.putOrderInfo.source = this.source
      this.putOrderInfo.operationId = this.cartOrderInfo.operationId
      var url = "https://hrcc8.com/api/order" //下单接口
      //var url = "http://hrc/api/order" //下单接口
      //alert(url)
    }
      // if(this.putOrderInfo.machineId == 293){
      //   if(this.cartType == 0){
      //     alert('cartType'+this.cartType)
      //     alert('goods_id:'+this.putOrderInfo.goodsId)
      //     alert('machineId:'+this.putOrderInfo.machineId)
      //     alert('mainboradNo:'+this.putOrderInfo.mainboradNo)
      //     alert('userId:'+this.putOrderInfo.userId)
      //     alert('openid:'+this.putOrderInfo.openid)
      //     alert('merchantId:'+this.putOrderInfo.merchantId)
      //     alert('source:'+this.putOrderInfo.source)
      //     alert('operationId:'+this.putOrderInfo.operationId)
      //   }else{
      //     alert('cartType'+this.cartType)
      //     alert('machineId:'+this.putOrderInfo.machineId)
      //     alert('userId:'+this.putOrderInfo.userId)
      //     alert('openid:'+this.putOrderInfo.openid)
      //     alert('merchantId:'+this.putOrderInfo.merchantId)
      //     alert('operationId:'+this.putOrderInfo.operationId)
      //     alert('source:'+this.putOrderInfo.source)
      //     alert('goods:'+this.putOrderInfo.goods)
      //   }
      // }
      

      // console.log(this.putOrderInfo.userId)
      // console.log(this.putOrderInfo.openid)
      // console.log(this.putOrderInfo.source)
      // console.log(this.putOrderInfo.merchantId)
      // console.log(this.putOrderInfo.operationId)
      // console.log(this.putOrderInfo.machineId)
      // console.log(this.putOrderInfo.goods)
      
      //axios请求后端下单接口"http://hrcc8.com/api/order"
      //测试接口http:/hrcc8.com/api/ordercatr
      
      this.axios.post(   //请求方式
      url,  //接口地址
      this.putOrderInfo
      )    //传递参数 
      .then(response =>{
          // alert(1)
          //alert(this.requestNum)
          if(response.data.code == 0){

            //记录单号
            // if(response.data.data.data.bankRequestNum == undefined){
            //   alert("支付信息缺失！")
            // }
            if(response.data.data.data.bankRequestNum != undefined){
              this.bankRequestNum = response.data.data.data.bankRequestNum
            }else{
              this.bankRequestNum = ''
            }
            if(response.data.data.data.orderNum != undefined){
              this.orderNum = response.data.data.data.orderNum
            }else{
              this.orderNum = ''
            }
            if(response.data.data.data.requestNum != undefined){
              this.requestNum = response.data.data.data.requestNum
            }else{
              this.requestNum = ''
            }
            
            //如果下单成功，根据返回的数据js调用支付
            //开始调用付款（分开微信还是支付宝）
            //微信调起支付
            if(this.source == 1){
              //alert("调起支付")
                var that = this
                function onBridgeReady(){
                  // alert("appId:"+ response.data.data.data.bankRequest.APPID)
                  // alert("timeStamp:"+ response.data.data.data.bankRequest.TIMESTAMP)
                  // alert("nonceStr:"+ response.data.data.data.bankRequest.NONCESTR)
                  // alert("package:"+ response.data.data.data.bankRequest.PACKAGE)
                  // alert("signType:"+ response.data.data.data.bankRequest.SIGNTYPE)
                  // alert("paySign:"+ response.data.data.data.bankRequest.PAYSIGN) 
                   WeixinJSBridge.invoke(
                      'getBrandWCPayRequest', {
                         "appId": response.data.data.data.bankRequest.APPID,        //"wx2421b1c4370ec43b"  公众号名称，由商户传入     
                         "timeStamp": response.data.data.data.bankRequest.TIMESTAMP, //"1395712654"  时间戳，自1970年以来的秒数     
                         "nonceStr": response.data.data.data.bankRequest.NONCESTR,   //"e61463f8efa94090b1f366cccfbbb444" 随机串     
                         "package": response.data.data.data.bankRequest.PACKAGE,     //"prepay_id=u802345jgfjsdfgsdg888"     
                         "signType": response.data.data.data.bankRequest.SIBGTYPE,   //"MD5"  微信签名方式：     
                         "paySign": response.data.data.data.bankRequest.PAYSIGN     //"70EA570631E4BB79628FBCA90534C63FF7FADD89" 微信签名 
                      },
                      function(res){ 
                      //alert(res.err_msg)                     
                      if(res.err_msg == "get_brand_wcpay_request:ok" ){
                          //使用以上方式判断前端返回,微信团队郑重提示：
                          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                          //alert("支付成功")
                          that.checkPay()
                          //关闭支付页面
                      } 
                      if(res.err_msg == "get_brand_wcpay_request:cancel"){
                          that.fshowPayBtn()
                          //alert("未完成支付")
                      }
                      if(res.err_msg == "get_brand_wcpay_request:fail"){
                          //支付失败，显示支付失败页面
                          //alert("支付失败！")
                          that.errorPay()
                      }   
                   }); 
                }
                //微信JSAPI调起支付
                if (typeof WeixinJSBridge == "undefined"){
                   if( document.addEventListener ){
                        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                   }else if (document.attachEvent){
                        document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
                        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                   }
                }else{
                    onBridgeReady();
                }
            }
            //支付宝调起支付
            if(this.source == 2){
                var that = this
                let getTradeNO = response.data.data.data.bankRequest.TRADENO
                //alert(getTradeNO)
                //由于js的载入是异步的，所以可以通过该方法，当AlipayJSBridgeReady事件发生后，再执行callback方法
                function ready(callback){
                     if (window.AlipayJSBridge) {
                         callback && callback();
                     } else {
                         document.addEventListener('AlipayJSBridgeReady', callback, false);
                     }
                 }
                 function tradePay(tradeNO){
                    //alert("开始支付喽！")
                    ready(function(){
                         // 通过传入交易号唤起快捷调用方式(注意tradeNO大小写严格)
                         AlipayJSBridge.call("tradePay", {
                            tradeNO: tradeNO
                         }, function (data) {
                             //log(JSON.stringify(data));
                             if ("9000" == data.resultCode) {
                                //console.log("支付成功");
                                //alert("支付成功！")
                                //页面显示成功
                                //调用后端接口查询到款情况
                                that.checkPay()
                             }
                             if("6001" == data.resultCode){
                                //支付失败
                                //调用显示支付失败页面
                                that.fshowPayBtn()
                                alert("您已放弃支付")
                                //that.checkPay()
                             }
                             if("4000" == data.resultCode){
                                //支付失败
                                //调用显示支付失败页面
                                //alert("支付失败")
                                that.errorPay()
                             }
                         });
                    });
                }
                //阿里JSAPI调起支付
                tradePay(getTradeNO); 
            }
          }else if(response.data.code == 301){
            //alert("商户信息异常,请联系商户！")
            this.tipInfo = "您的订单已经超时，请您重新选购！";
            this.tipReload = true;
            this.tipshow = true;
          }else if(response.data.code == 400){
            this.tipInfo = response.data.msg;
            this.tipshow = true;
          }else if(response.data.code == 401){
            this.tipInfo = "商户信息异常,请联系商户！";
            this.tipshow = true;
          }else if(response.data.code == 402){
            this.tipInfo = "商品金额异常,请重新选择商品！";
            this.tipshow = true;
          }else if(response.data.code == 403){
            this.tipInfo = response.data.msg;
            this.tipReload = true;
            this.tipshow = true;
            this.btnshow = false;
            this.btnreload = true;
            this.btnpay = true;
            
          }else{
            //this.tipInfo = "账户异常,请联系商户！";
            this.tipInfo = "code:"+response.data.code+"  msg:"+response.data.msg;
            this.tipshow = true;
          }
          
      })
      .catch((error) => {
          //console.log(error)
          //alert("非常抱歉，出现系统内部错误！")
          this.tipInfo = "非常抱歉，系统出现内部错误！"+error;
          //this.tipInfo = error;
          this.tipshow = true;
          //显示支付按钮
          this.showPayBtn = true
      })
    },
    handleBack:function(){
      this.order_page = false
      this.pay_page = false
      this.multi_page = true
      this.bsoll = true
    },
    checkPay: function(){
      //alert('查询支付状态')
      if(this.cartType == 1){
        this.pay_page = false
      }else{
        this.order_page = false
      }
      this.pay_await_page = true
      var that = this
      //每隔1S调用一下接口查询支付状态
      function checkOrder(){
        let checkPayStatusUrl = "https://hrcc8.com/api/orderStatus" //查询订单支付状态
        //alert(that.requestNum)
        that.axios.post(                //请求方式
        checkPayStatusUrl,              //接口地址
        {
          orderSn:that.requestNum
        },    //传递参数  
        {timeout: 1000 * 2})            //设置超时时间   
        .then(response =>{
          //alert(11111)
          //alert(response.data.data.data.status)
          if("undefined" != typeof response.data.data.data.status){
            if(response.data.data.data.status == "SUCCESS"){
                that.pay_await_page = false
                that.pay_success_page = true
                clearInterval(timer);
                clearTimeout(outer);
                that.goodsPush()
            }
          }
        });
      }
      //清除查询定时器
      function clear_check_timer(){
        clearInterval(timer);
      }
      //设定查询定时器
      var timer = setInterval(checkOrder, 1000 * 2);
      //设定超时定时器
      var outer = setTimeout(clear_check_timer, 1000 * 60 * 2);
      
    },
    errorPay: function(){
      this.order_page = false
      this.pay_fail_page = true
    },
    goodsPush: function(){
      this.pay_success_page = false
      this.goods_push_page = true
      //每隔2s调用接口查询一下出货状态
      var that = this
      //alert(that.requestNum)
      //每隔1S调用一下接口查询出货状态
      function checkShipment(){
        let checkShipmentStatusUrl = "https://hrcc8.com/api/getOrderStatus" //查询订单出货状态
        //alert(that.requestNum)
        that.axios.post(                //请求方式
        checkShipmentStatusUrl,              //接口地址
        {
          ordersn:that.requestNum
        },    //传递参数  
        {timeout: 1000 * 2})            //设置超时时间   
        .then(response =>{
          //alert(response.data.data.order_status)
          if("undefined" != typeof response.data.data.order_status){
            if(response.data.data.order_status == 2){
                //alert("success")
                clearInterval(pTimer);
                clearTimeout(pOuter);
                that.goodsPushSuccess();
            }
            if(response.data.data.order_status == 3 || response.data.data.order_status == 4){
                //alert("error")
                clearInterval(pTimer);
                clearTimeout(pOuter);
                that.goodsPushFail();
            }
            if(response.data.data.order_status == 1){
              //alert("正在出货")
            }
          }
        });
      }
      //清除查询定时器
      function clear_shipment_timer(){
        clearInterval(pTimer);
      }
      //设定查询定时器
      var pTimer = setInterval(checkShipment, 1000 * 2);
      //设定超时定时器
      var pOuter = setTimeout(clear_shipment_timer, 1000 * 60 * 2);
      
    },
    goodsPushSuccess: function(){
      this.goods_push_page = false
      this.goods_push_success_page = true
    },
    goodsPushFail: function(){
      this.goods_push_page = false
      this.goods_push_fail_page = true
    },
    fshowPayBtn: function(){
      this.showPayBtn = true
    },
    selectGoodsPay: function(that){  //带购物车的时候获取订单数据
      console.log(that);
      let info = {};
      let p_info = Array();
      let total_price = 0;
      let total_count = 0;
      let No_list = "";
      let machine_id = "";
      let merchantId = "";
      let operationId = "";
      for(let i in that){
        //总价格
        let goods_price = 0;
        goods_price = Number(that[i]['price']) *Number(that[i]['count']);
        total_price += goods_price;
        //总商品数量
        total_count += that[i]['count'];
        //货道列表
        if(i ==0){
          No_list = that[i]['No'];
        }else{
          No_list = No_list +','+ that[i]['No'];
        }
        //货机id
        machine_id = that[i]['machine_id'];
        //商户id
        merchantId = that[i]['merchantId'];
        //操作员id
        operationId = that[i]['operationId'];
        p_info[i] ='{"No":'+that[i]['No']+',"count":'+that[i]['count']+',"goods_id":'+that[i]['goods_id']+',"price":'+that[i]['price']+'}';
        // p_info[i]={
        //             'No':that[i]['No'],
        //             'count':that[i]['count'],
        //             'goods_id':that[i]['goods_id'],
        //             'price':that[i]['price']
        //           };
      }
      total_price = Math.round(total_price*100)/100   //总价格四舍五入保留2位小数
      info['total_price'] = total_price;
      info['total_count'] = total_count;
      info['No_list'] = No_list;
      info['machine_id'] = machine_id;
      info['merchantId'] = merchantId;
      info['operationId'] = operationId;
      info['goods'] = '['+p_info+']';
      this.cartOrderInfo = info;
      //console.log(info)
      this.multi_page = false
      this.pay_page = true
    },
    machineStatus: function(status){
      if(status == "on"){
        this.machine_alive = false;
        // this.tipInfo = "如果您前方有人正在购买商品，强烈建议您在上一位顾客购买后结束后再进行购买，避免造成出货混乱！";
        // this.tipshow = true;
      }
      if(status == "off"){
        this.multi_page = false;
        this.machinestatus = true;
        this.machine_alive = false;
      }
    }


  }
}
</script>

<style >
  body{
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue